// extracted by mini-css-extract-plugin
export var legendIndicator = "_c8-1";
export var legendRight = "_c8-0";